var map = {
	"./add-search-engine/icon.svg": "./src/assets/Mozilla/DesignTokens/Icons/assets/add-search-engine/icon.svg",
	"./audio-mute/icon.svg": "./src/assets/Mozilla/DesignTokens/Icons/assets/audio-mute/icon.svg",
	"./audio/icon.svg": "./src/assets/Mozilla/DesignTokens/Icons/assets/audio/icon.svg",
	"./blog/icon.svg": "./src/assets/Mozilla/DesignTokens/Icons/assets/blog/icon.svg",
	"./card-audio/icon.svg": "./src/assets/Mozilla/DesignTokens/Icons/assets/card-audio/icon.svg",
	"./card-video/icon.svg": "./src/assets/Mozilla/DesignTokens/Icons/assets/card-video/icon.svg",
	"./common-voice/icon.svg": "./src/assets/Mozilla/DesignTokens/Icons/assets/common-voice/icon.svg",
	"./delete/icon.svg": "./src/assets/Mozilla/DesignTokens/Icons/assets/delete/icon.svg",
	"./desktop/icon.svg": "./src/assets/Mozilla/DesignTokens/Icons/assets/desktop/icon.svg",
	"./extensions-update/icon.svg": "./src/assets/Mozilla/DesignTokens/Icons/assets/extensions-update/icon.svg",
	"./extensions/icon.svg": "./src/assets/Mozilla/DesignTokens/Icons/assets/extensions/icon.svg",
	"./facebook-container/icon.svg": "./src/assets/Mozilla/DesignTokens/Icons/assets/facebook-container/icon.svg",
	"./image/icon.svg": "./src/assets/Mozilla/DesignTokens/Icons/assets/image/icon.svg",
	"./inbox/icon.svg": "./src/assets/Mozilla/DesignTokens/Icons/assets/inbox/icon.svg",
	"./irl/icon.svg": "./src/assets/Mozilla/DesignTokens/Icons/assets/irl/icon.svg",
	"./labs/icon.svg": "./src/assets/Mozilla/DesignTokens/Icons/assets/labs/icon.svg",
	"./listen/icon.svg": "./src/assets/Mozilla/DesignTokens/Icons/assets/listen/icon.svg",
	"./mozilla/icon.svg": "./src/assets/Mozilla/DesignTokens/Icons/assets/mozilla/icon.svg",
	"./notes/icon.svg": "./src/assets/Mozilla/DesignTokens/Icons/assets/notes/icon.svg",
	"./paste/icon.svg": "./src/assets/Mozilla/DesignTokens/Icons/assets/paste/icon.svg",
	"./pocket-list/icon.svg": "./src/assets/Mozilla/DesignTokens/Icons/assets/pocket-list/icon.svg",
	"./pocket/icon.svg": "./src/assets/Mozilla/DesignTokens/Icons/assets/pocket/icon.svg",
	"./popup-block/icon.svg": "./src/assets/Mozilla/DesignTokens/Icons/assets/popup-block/icon.svg",
	"./printer/icon.svg": "./src/assets/Mozilla/DesignTokens/Icons/assets/printer/icon.svg",
	"./release-notes/icon.svg": "./src/assets/Mozilla/DesignTokens/Icons/assets/release-notes/icon.svg",
	"./secure-mixed/icon.svg": "./src/assets/Mozilla/DesignTokens/Icons/assets/secure-mixed/icon.svg",
	"./send-to-device/icon.svg": "./src/assets/Mozilla/DesignTokens/Icons/assets/send-to-device/icon.svg",
	"./send/icon.svg": "./src/assets/Mozilla/DesignTokens/Icons/assets/send/icon.svg",
	"./watch/icon.svg": "./src/assets/Mozilla/DesignTokens/Icons/assets/watch/icon.svg",
	"./window-new/icon.svg": "./src/assets/Mozilla/DesignTokens/Icons/assets/window-new/icon.svg"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/Mozilla/DesignTokens/Icons/assets recursive ^\\.\\/.*\\/icon\\.svg$";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Mozilla/DesignTokens/Icons/assets ^\.\/.*\/icon\.svg$
// module id = ./src/assets/Mozilla/DesignTokens/Icons/assets recursive ^\.\/.*\/icon\.svg$
// module chunks = 0